import React from "react";
import { Reveal } from "../shared/Reveal";

export default function Pillars() {
  return (
    <section id="pillars" className="pillars arcsec">
      <div className="arc" />
      <div className="wrap">
        <Reveal className="eyebrow" tag="div" style={{ textAlign: "left" }}>WHY IT MATTERS</Reveal>
        <div className="pillarlist">
          <Reveal className="rv pillar lead-pillar" tag="div">
            <span className="pnum">01</span>
            <span className="ptext">No amount of Solar PV or Battery Storage will eliminate the energy your building is <span className="g">already wasting.</span></span>
          </Reveal>
          <Reveal className="rv pillar" tag="div">
            <span className="pnum">02</span>
            <span className="ptext">Case studies have demonstrated energy savings of <span className="g">up to 30%</span> through intelligent monitoring and optimisation.</span>
          </Reveal>
          <Reveal className="rv pillar" tag="div">
            <span className="pnum">03</span>
            <span className="ptext">Working with some of the <span className="g">UK's largest</span> commercial organisations and manufacturers.</span>
          </Reveal>
          <Reveal className="rv pillar" tag="div">
            <span className="pnum">04</span>
            <span className="ptext"><span className="g">Knowledge</span> Before Investment.</span>
          </Reveal>
        </div>
        <div className="philpills">
          {["Knowledge Before Investment", "Making the Invisible Visible", "Eliminate Waste First", "Building Intelligence Before Capital Investment"].map((p) => (
            <Reveal className="rv philpill" tag="span" key={p}>{p}</Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
